import {Grid, Theme, useMediaQuery} from '@mui/material'

const HD_WIDTH_BREAKPOINT = 1366

type LayoutProps = {
  generalSlot?: React.ReactNode
  rcfaSlot?: React.ReactNode
  scoreProgressSlot?: React.ReactNode
  expertSystemSlot?: React.ReactNode
  runningTimesSlot?: React.ReactNode
  qualityKpisSlot?: React.ReactNode
}

export const PlantStatusSummaryLayout = ({
  generalSlot,
  runningTimesSlot,
  expertSystemSlot,
  scoreProgressSlot,
  rcfaSlot,
  qualityKpisSlot
}: LayoutProps) => {
  const isBelowHdResolution = useMediaQuery<Theme>(({breakpoints}) =>
    breakpoints.down(HD_WIDTH_BREAKPOINT)
  )
  const mdLeftNumberOfColumns = isBelowHdResolution ? 8 : 6
  const mdRightNumberOfColumns = isBelowHdResolution ? 4 : 6

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={mdLeftNumberOfColumns}>
        <Grid container spacing={2} direction={'column'}>
          <Grid item>{generalSlot}</Grid>
          <Grid item>{qualityKpisSlot}</Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={mdRightNumberOfColumns}>
        <Grid container spacing={2} direction={'column'}>
          <Grid item>{runningTimesSlot}</Grid>
          <Grid item>{expertSystemSlot}</Grid>
          <Grid item>{rcfaSlot}</Grid>
          <Grid item>{scoreProgressSlot}</Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

